import {Vector3} from 'three';
import {rotateAuthoredBone} from './authored-attention.js';
const right=new Vector3(1,0,0),up=new Vector3(0,1,0);
/** Bounded semantic overlays on the source chest/neck/head, before terrain IK. */
export function applyOriginalRabbitBehavior(item,pose){
 const browse=Math.max(0,Math.min(1,pose.forage||0)),rest=Math.max(0,Math.min(1,pose.rest||0)),attention=Math.max(0,Math.min(1,pose.alert||0));
 // Distribute browsing through the spine and neck so the head can actually
 // reach meadow height, without collapsing it into one extreme head rotation.
 rotateAuthoredBone(item.bones.get('Spine'),item.placement,right,browse*.25);
 rotateAuthoredBone(item.bones.get('Spine001'),item.placement,right,browse*.10);
 rotateAuthoredBone(item.bones.get('Neck'),item.placement,right,browse*.60+rest*.055*(1-attention));
 rotateAuthoredBone(item.bones.get('Head'),item.placement,right,browse*.20+rest*.035*(1-attention));
 rotateAuthoredBone(item.bones.get('Head'),item.placement,up,(pose.headYaw||0)*.65);
}
